import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmailSignature from './EmailSignature';
import EmptySpace from '../modules/EmptySpace';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, linkText } from '../../../helpers/getEmailStyles';

class BanStatusServiceStatusUnBanned extends React.Component {

	render() {

		const { content: { userName, adminMail, logo, siteName } } = this.props;
		let mailTo = 'mailto:' + adminMail;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Bonjour {userName},
					</div>
					<EmptySpace height={20} />
					<div>
						Votre compte <span style={fontWeightBold}>{siteName}</span> a été réactivé ! Vous pouvez maintenant vous connecter et commencer à l'utiliser.
					</div>
					<EmptySpace height={20} />
					<div>
						Si vous avez des questions, n'hésitez pas à contacter notre <a href={mailTo} style={linkText}>équipe de support</a>.
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default BanStatusServiceStatusUnBanned;